import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import './LeaveLiverWindow.modules.css';
import { OPENING, } from "../constants/openingConstant"

const LeaveLiverWindow = forwardRef(({ onComplete }, ref) => {
  // 開始までのカウントダウン
  const [timeLeft, setTimeLeft] = useState(0);
  const [isAgreed, setIsAgreed] = useState(false);

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else {
      // 親コンポーネントに処理完了を通知
      if (isAgreed == true) {
        onComplete();
      }
    }
  }, [timeLeft]);

  // 外部から呼び出せる関数を定義
  useImperativeHandle(ref, () => ({
    agreed: () => {
      setIsAgreed(true);
      setTimeLeft(OPENING.OPENING_WAIT_TIME);
    },
  }));

  return (
    <div class="leave_liver_window">
      <div class="announce">
        <h1>配信開始までしばらくお待ち下さい</h1>
        <div className="countdown-container">
          {
            isAgreed ? (
              <div>
                <h2>配信開始まであと</h2>
                <div className="countdown">
                  {timeLeft}秒
                </div>
              </div>
            ) : (
              <div>
                <h2>【注意事項】</h2>
                <div>本作品はフィクションです。登場する人物はすべて架空です</div>
                <div>実在の人物や団体とは一切関係ありません</div>
                <div>内容についての苦情やクレームは受け付けません</div>
                <p></p>
                <div>以上を了承いただけた場合は、同意する、を入力してください</div>
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
}
);

export default LeaveLiverWindow;